export default {
    'en.global': require('../../lang/en/webshop/global.php'),
    'en.menu': require('../../lang/en/webshop/menu.php'),
    'en.homepage': require('../../lang/en/webshop/pages/open/homepage.php'),
    'en.products': require('../../lang/en/webshop/pages/open/products.php'),
    'en.categories': require('../../lang/en/webshop/pages/open/categories.php'),
    'en.cart': require('../../lang/en/webshop/pages/open/cart.php'),
    'en.brands': require('../../lang/en/webshop/pages/open/brands.php'),
    'en.all': require('../../lang/en/all.php'),
    'en.errors': require('../../lang/en/webshop/errors.php'),
    'en.snotify': require('../../lang/en/webshop/snotify.php'),
    'en.breadcrumbs': require('../../lang/en/breadcrumbs.php'),
    'en.cookiewall': require('../../lang/en/cookiewall.php'),
    'en.invoices': require('../../lang/en/webshop/pages/auth/invoices.php'),
    'en.bestsellers': require('../../lang/en/webshop/pages/open/bestsellers.php'),
    'en.my-account': require('../../lang/en/webshop/pages/auth/my-account.php'),
    'en.throttled': require('../../lang/en/throttled.php'),
    'en.checkout': require('../../lang/en/webshop/pages/auth/checkout.php'),
    'nl.global': require('../../lang/nl/webshop/global.php'),
    'nl.menu': require('../../lang/nl/webshop/menu.php'),
    'nl.homepage': require('../../lang/nl/webshop/pages/open/homepage.php'),
    'nl.products': require('../../lang/nl/webshop/pages/open/products.php'),
    'nl.categories': require('../../lang/nl/webshop/pages/open/categories.php'),
    'nl.cart': require('../../lang/nl/webshop/pages/open/cart.php'),
    'nl.brands': require('../../lang/nl/webshop/pages/open/brands.php'),
    'nl.all': require('../../lang/nl/all.php'),
    'nl.errors': require('../../lang/nl/webshop/errors.php'),
    'nl.snotify': require('../../lang/nl/webshop/snotify.php'),
    'nl.breadcrumbs': require('../../lang/nl/breadcrumbs.php'),
    'nl.cookiewall': require('../../lang/nl/cookiewall.php'),
    'nl.invoices': require('../../lang/nl/webshop/pages/auth/invoices.php'),
    'nl.bestsellers': require('../../lang/nl/webshop/pages/open/bestsellers.php'),
    'nl.my-account': require('../../lang/nl/webshop/pages/auth/my-account.php'),
    'nl.throttled': require('../../lang/nl/throttled.php'),
    'nl.checkout': require('../../lang/nl/webshop/pages/auth/checkout.php'),
}
